module.exports = __webpack_public_path__ + "img/3_1.c26914d4.png";